/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 *
 * This component is used to display the required
 * privacy statement which can be found in a link in the
 * about tab.
 */

export function Privacy() {
  return (
    <div>
      <h1>Privacy Statement</h1>
    </div>
  );
}
